import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseServiceFacade, GenericApiCall } from 'src/app/common/store/types';
import { AppState } from '../types';
import {
  CurrentUserModel,
  LockoutModel,
  RegisterModel,
  User,
  UserConnectionHistory,
  UserDetailModel,
  UserModel,
} from './type';
import { userActions } from './user.actions';
import { userSelectors } from './user.selectors';
import { Action } from '../view/types';

@Injectable()
export class UserService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }

  getById: GenericApiCall<UserDetailModel, string> = this.genericApiCall(
    userActions.getById,
    userSelectors.getById,
    true,
  );

  getMainSalesTeamById: GenericApiCall<number | undefined, string> =
    this.genericApiCall(
      userActions.getMainSalesTeamById,
      userSelectors.getMainSalesTeamById,
      true,
    );

  add: GenericApiCall<User, UserModel> = this.genericApiCall(
    userActions.add,
    userSelectors.add,
    true,
  );

  update: GenericApiCall<User, User> = this.genericApiCall(
    userActions.update,
    userSelectors.update,
    true,
  );

  lockout: GenericApiCall<boolean, LockoutModel> = this.genericApiCall(
    userActions.lockout,
    userSelectors.lockout,
    true,
  );

  getCurrentUser: GenericApiCall<CurrentUserModel, void> = this.genericApiCall(
    userActions.getCurrentUser,
    userSelectors.getCurrentUser,
    true,
  );

  getConnectionHistoriesById: GenericApiCall<UserConnectionHistory[], string> =
    this.genericApiCall(
      userActions.getConnectionHistoriesById,
      userSelectors.getConnectionHistoriesById,
      true,
    );

  getStatusActions: GenericApiCall<Action[], string> = this.genericApiCall(
    userActions.getStatusActions,
    userSelectors.getStatusActions,
    true,
  );
}
